export default function LeftIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6Z" />
		</svg>
	)
}
